import { getStartDate } from "@kvix/shared";
import { Fab, makeStyles } from "@material-ui/core";
import { format, isThisWeek, isToday, isYesterday } from "date-fns";
import { differenceInSeconds } from "date-fns/esm";
import { sv } from "date-fns/locale";
import i18next from "i18next";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { KvixIcon } from "../../icons";
import { CardBase } from "./partials/CardBase";
import { CardMeta } from "./partials/CardMeta";
import { CardWrapper } from "./partials/CardWrapper";
const useStyles = makeStyles((theme) => ({
    playButton: {
        "&.MuiFab-root": {
            color: theme.palette.common.white,
            minHeight: 24,
            minWidth: 24,
            maxHeight: 24,
            maxWidth: 24,
            boxShadow: "none",
            marginRight: 7,
            pointerEvents: "none"
        },
        "&.MuiFab-root svg": {
            height: "0.9em",
            width: "0.9em"
        }
    }
}));
export const AnytimeCard = (props) => {
    var _a;
    const { options, filterByChip } = props;
    const { t, ready } = useTranslation("general");
    const classes = useStyles(props);
    const wasLiveAt = useMemo(() => {
        const startDate = getStartDate(options);
        const hideDate = isThisWeek(startDate, { weekStartsOn: 1 });
        const time = format(startDate, "HH:mm");
        const today = isToday(startDate) && `${t("today")} ${time}`;
        const yesterday = isYesterday(startDate) && `${t("yesterday")} ${time}`;
        const translatedDay = format(startDate, "ccc", {
            locale: i18next.language === "sv-SE" && sv
        });
        const day = translatedDay.charAt(0).toUpperCase() + translatedDay.slice(1);
        const date = startDate.getDate();
        const month = format(startDate, "MMM", {
            locale: i18next.language === "sv-SE" && sv
        });
        const tmpDay = hideDate ? `${day} ${time}` : day;
        const tmpDate = hideDate ? "" : `${date} ${month}`;
        const monthAndDate = `${tmpDay} ${tmpDate}`;
        return today || yesterday || monthAndDate;
    }, [options]);
    const progress = useMemo(() => {
        var _a;
        if ((_a = props.progress) === null || _a === void 0 ? void 0 : _a.currentTime) {
            const diff = differenceInSeconds(props.progress.endTimestamp, props.progress.startTimestamp);
            return (props.progress.currentTime / diff) * 100;
        }
    }, [props.progress]);
    if (!ready) {
        return null;
    }
    return (React.createElement(CardWrapper, null,
        React.createElement(CardBase, { imageUrl: options.imageUrl, title: options.title, instructorName: options.instructorName, rating: options.rating, link: `/replay/${props.options.programId}/${props.options.id}`, isLiked: props.isLiked, partnerTitle: options.partnerTitle, playButton: React.createElement(Fab, { className: classes.playButton, color: "primary", disableFocusRipple: true },
                React.createElement(KvixIcon.Play, null)), toggleFavourite: props.toggleFavourite ? () => props.toggleFavourite({ session: props.options }) : null, wasLiveAt: wasLiveAt, progress: progress }),
        React.createElement(CardMeta, { duration: options.duration, filterByChip: filterByChip, language: ((_a = options.tags) === null || _a === void 0 ? void 0 : _a.includes("English")) ? "English" : "Swedish" })));
};
//# sourceMappingURL=AnytimeCard.js.map